import React, { useContext } from "react";
import { styled } from "@mui/material/styles";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import ErrorScreen from "core/components/ErrorScreen";
import { useLocation } from "react-router-dom";
import HttpContext from "core/utils/httpContext";
import usePageview from "core/hooks/usePageview";

const Root = styled("div")({
  minHeight: "60vh",
  height: "100%",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export default function NoMatchScreen() {
  const { t } = useTranslation("arena");
  const context = useContext(HttpContext);
  const location = useLocation();

  usePageview(location.pathname, t("noMatchScreen.title"));

  // Set 404 status for SSR
  if (context) {
    context.status = 404;
  }

  return (
    <Root>
      <Helmet>
        <title>{t("noMatchScreen.title")}</title>
      </Helmet>

      <ErrorScreen
        code={404}
        icon={SentimentVeryDissatisfiedIcon}
        title={t("noMatchScreen.title")}
        text={t("noMatchScreen.text")}
      />
    </Root>
  );
}
